// extracted by mini-css-extract-plugin
module.exports = {"button":"PoGroupInvoicePrintButton_button__91C1I","button-ltr":"PoGroupInvoicePrintButton_button-ltr__3dN_e"};